export default (text = "", limit = 15) => {
  return text.length > limit ? `${text.substring(0, limit)}..` : text
}
